export class ProductsEndpoints {
  static Brand(brand: string): string {
    return `/${brand.toLowerCase()}/brands`;
  }

  static CountriesConfig(brand: string): string {
    return `/${brand.toLowerCase()}/quoteCountriesConfig`;
  }

  static Underwriters(brand: string): string {
    return `/${brand.toLowerCase()}/underwriters`;
  }

  static Features(brand: string, insuranceContractId: number): string {
    return `/${brand.toLowerCase()}/features/${insuranceContractId}`;
  }

  static TenderTypes(brand: string, insuranceContractId: number): string {
    return `/${brand.toLowerCase()}/insuranceContract/${insuranceContractId}/tenderTypes`;
  }

  static Currencies(brand: string): string {
    return `/${brand.toLowerCase()}/currencies`;
  }

  static QuoteConfig(brand: string): string {
    return `/${brand.toLowerCase()}/baseQuoteConfig`;
  }

  static PlanSummary(brand: string, planId: number): string {
    return `/${brand.toLowerCase()}/plans/${planId}`;
  }

  static PlanBenefits(brand: string, planId: number): string {
    return `/${brand.toLowerCase()}/plans/${planId}/benefits`;
  }

  static PlanOptions(brand: string, planId: number): string {
    return `/${brand.toLowerCase()}/plans/${planId}/options`;
  }

  static DonationConfig(brand: string): string {
    return `/${brand.toLowerCase()}/donationConfig`;
  }
}
